/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const productVariants = {
  productVariants: {
    style: 'Estilo',
    selectedEstilo: 'Estilo selecionado',
    size: 'Medir',
    color: 'Cor',
    sizeGuideLabel: 'Estilo do guia',
  },
};
